import { EventType } from "@/global/store/data/types";
import { createState } from "@/global/store/zustand_store";
import { NotificationModal } from "@/shared/common/InfoPopup/NotificationModal";
import { useTheme, Box, Typography, Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import { eventsState } from "@/global/store/data/purchaseSeats/events";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import React from "react";
import { CombinedEventCard } from "@/shared/common/EventCard/CombinedEventCard";

export const useSPEventSelectorModal = createState({
  isOpen: false,
  isOpened: false,
  eventsSelected: [] as EventType[],
  eventsToSelect: [] as EventType[],
});
export function SPEventSelectorModal() {
  const { sm: smDown } = useCssMediaQuery("down");
  const theme = useTheme();
  const dispatch = useDispatch();
  const { isOpen, eventsToSelect, eventsSelected, set, reset } =
    useSPEventSelectorModal();
  const [isPrevented, setIsPrevented] = React.useState(false);

  const onConfirm = () => {
    dispatch(eventsState.actions.addSelectionMultiple(eventsSelected));
    set({ isOpen: false });
  };
  const onSelect = (evt: EventType) => {
    const isSelected = eventsSelected.some((ev) => ev.eventCode == evt.eventCode); // prettier-ignore
    if (isSelected) {
      const newSelected = eventsSelected.filter((ev) => ev.eventCode != evt.eventCode); //prettier-ignore
      set({ eventsSelected: newSelected });
    } else {
      set({ eventsSelected: [...eventsSelected, evt] });
    }
  };
  const onClose = () => {
    reset();
    // if (isPrevented) {
    //   set({ isOpen: false, isOpened: true });
    // } else {
    //   reset();
    // }
    // setIsPrevented(false);
  };

  React.useEffect(() => {
    set({ eventsSelected: eventsToSelect });
  }, [eventsToSelect]);

  return (
    <NotificationModal
      isOpen={isOpen}
      hideTitleIcon
      onClose={() => onClose()}
      onClickSecondaryButton={() => onClose()}
      onClickPrimaryButton={() => onConfirm()}
      primaryButtonProps={{ isDisabled: eventsSelected.length == 0 }}
      title="Congrats!"
      primaryButtonText="Add Event"
      secondaryButtonText="Decline Event"
      renderBody={() => {
        return (
          <Box>
            <Box p={smDown ? 2 : 3} pb={12}>
              <Box>
                <Typography variant="body1">
                  You&apos;ve unlocked a special event!
                </Typography>
              </Box>
              <Box px={1} mt={2}>
                <Grid container spacing={2}>
                  {eventsToSelect.map((evt) => {
                    const isSelected = eventsSelected.some(
                      (sEvt) => sEvt.eventCode == evt.eventCode
                    );

                    return (
                      <Grid item xs={12} key={evt.eventCode}>
                        <CombinedEventCard
                          variant="upcoming"
                          event={evt}
                          // isDisabled={isMaxEventCountReached && !isSelected}
                          isSelected={isSelected}
                          onSelect={() => onSelect(evt)}
                          isInvPreviewButtonHidden={true}
                        />
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            </Box>
            {/* <Box p={smDown ? 2 : 3}>
              <FormControlLabel
                label="Don't show this again."
                control={
                  <Checkbox
                    checked={isPrevented}
                    onChange={(ev) => {
                      setIsPrevented(ev.target.checked);
                    }}
                  />
                }
              />
            </Box> */}
          </Box>
        );
      }}
    />
  );
}
